import React, { useCallback, useState } from 'react'
import { useQuery, queryCache } from 'react-query'
import Layout from '../../components/Layout'
import { useWithAuth } from '../App'
import type { Reports } from './utils'
import { ReportsPanel } from './ReportsPanel'
import { PlaceHolder } from '../../utils/withLoading'

const endpoint = '/report/rest/examination'

type Props = {
  location: {
    state: {
      diagnosis: {
        id: number
        inquired: boolean
        code: string
        status: string
        patient: {
          id: number
        }
      }
    }
  }
  onClose: () => void
}

function Report({ location, onClose }: Props) {
  const withAuth = useWithAuth()
  const normalisedDiagnosis = location.state.diagnosis
  const patient = location.state.diagnosis.patient
  const [ready, setReady] = useState<boolean>(true)

  const { status, data: reportData } = useQuery<
    { models: Array<Reports> },
    string
  >(
    `reports-${normalisedDiagnosis.id}`,
    () =>
      withAuth(
        `${endpoint}/${normalisedDiagnosis.id}/reports`,
        {
          method: 'GET',
        },
        true
      ),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )
  const handleRefresh = useCallback(() => {
    setReady(false)
    queryCache
      .refetchQueries(`reports-${normalisedDiagnosis.id}`)
      .then(() => setReady(true))
  }, [])

  return (
    <Layout>
      {(status === 'loading' || !ready) && <PlaceHolder />}
      {reportData && ready && (
        <ReportsPanel
          code={normalisedDiagnosis.code}
          reports={reportData.models}
          patient={patient}
          id={normalisedDiagnosis.id}
          onClose={onClose}
          handleRefresh={handleRefresh}
          inquired={normalisedDiagnosis.inquired}
          diagnosisStatus={normalisedDiagnosis.status}
        ></ReportsPanel>
      )}
    </Layout>
  )
}

export default Report
